import { Block } from '@components/core-ui/Block';
import { Switch } from '@components/core-ui/form-elements/Switch';
import { useAuthContext } from '@providers/AuthProvider';
import { useAPI } from '@providers/useAPI';
import { useQuery } from '@tanstack/react-query';
import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import { createFetchTranscriptionSettingsQueryFn } from 'app/queries/transcriptionSettings/createFetchTranscriptionSettingsQueryFn';
import { transcriptionSettingsKeys } from 'app/queries/transcriptionSettings/transcriptionSettingsKeys';

export const ForeignLanguageBlock = () => {
  const { organization } = useAuthContext();
  const { call } = useAPI();
  const { form, setForm } = usePageContext();
  const { data, isError } = useQuery({
    queryKey: transcriptionSettingsKeys.organization(organization?.id),
    queryFn: createFetchTranscriptionSettingsQueryFn(call),
    enabled: !!organization?.id,
  });

  if (isError || data?.foreignLanguageRemovalAvailable !== true) {
    return null;
  }

  return (
    <Block title="Foreign language" description="Remove non-English speech from the transcript.">
      <Switch
        label="Remove foreign language"
        checked={form.item.userRequestedForeignLanguageRemoval === true}
        onChange={() =>
          setForm((previousForm) => ({
            ...previousForm,
            item: {
              ...previousForm.item,
              userRequestedForeignLanguageRemoval: !previousForm.item.userRequestedForeignLanguageRemoval,
            },
          }))
        }
        testId="remove-foreign-language-switch"
      />
    </Block>
  );
};
